// Navbar scroll effect
const nav = document.getElementById('navbar');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  });
  // Trigger on load in case page is pre-scrolled
  nav.classList.toggle('scrolled', window.scrollY > 60);

  // El navbar arranca transparente y pasa a sólido al hacer scroll en las páginas
  // que tienen una foto justo debajo (home, colección, producto, quiénes somos).
  // En páginas sin imagen (legales, carrito, buscador) se mantiene sólido siempre,
  // porque un navbar transparente ahí dejaría el texto ilegible sobre fondo claro.
  const lightBgPages = ['/cart', '/search', '/pages/contacto', '/pages/envios', '/pages/devoluciones', '/pages/privacidad', '/pages/aviso-legal', '/pages/tallas-guia'];
  const path = window.location.pathname;
  const isLightBg = lightBgPages.some(p => path.includes(p));
  if (isLightBg) {
    nav.classList.add('nav-solid');
  }
}

// Fade-up on scroll (IntersectionObserver)
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) e.target.classList.add('visible');
  });
}, { threshold: 0.12 });
document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

// Atelier category filter (filters by data-tags attribute)
document.querySelectorAll('.cat-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.cat-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const tag = (btn.dataset.tag || btn.textContent.toLowerCase().trim().replace(/\s+/g, '-'));

    document.querySelectorAll('.product-card').forEach(card => {
      const cardTags = card.dataset.tags || '';
      if (tag === 'all' || cardTags.includes(tag)) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  });
});

// Mobile menu toggle
const menuToggle = document.getElementById('menuToggle');
if (menuToggle) {
  menuToggle.addEventListener('click', () => {
    const links = document.querySelector('.nav-links');
    if (!links) return;
    if (links.style.display === 'flex') {
      links.style.display = 'none';
    } else {
      links.style.cssText = 'display:flex;flex-direction:column;position:fixed;top:70px;left:0;right:0;background:rgba(255,255,255,0.98);padding:30px 8%;gap:24px;backdrop-filter:blur(8px);z-index:999;border-top:1px solid rgba(122,0,24,0.15);';
    }
  });
}


// ── Vegga Welcome Letter (sobre animado en la home, siempre al entrar) ────
(function () {
  var overlay = document.getElementById('vegga-welcome-overlay');
  if (!overlay) return;

  var closeBtn = document.getElementById('vw-close');
  var reopenTab = document.getElementById('vw-reopen-tab');
  var timers = [];

  function addClass(cls, delay) {
    timers.push(setTimeout(function () {
      overlay.classList.add(cls);
    }, delay));
  }

  function closeLetter() {
    timers.forEach(clearTimeout);
    overlay.classList.add('vw-hiding');
    overlay.classList.remove('vw-visible');
    setTimeout(function () {
      overlay.style.display = 'none';
      if (reopenTab) {
        requestAnimationFrame(function () {
          reopenTab.classList.add('vw-tab-show');
        });
      }
    }, 650);
  }

  function reopenLetter() {
    if (reopenTab) reopenTab.classList.remove('vw-tab-show');
    overlay.classList.remove('vw-hiding');
    overlay.classList.remove('vw-card-visible');
    overlay.style.display = 'flex';
    void overlay.offsetWidth; // forzar reflow para reiniciar la transición
    overlay.classList.add('vw-visible');
    // El sobre ya está oculto (vw-envelope-hide sigue puesto); solo se despliega la carta
    requestAnimationFrame(function () {
      setTimeout(function () {
        overlay.classList.add('vw-card-visible');
      }, 40);
    });
    if (closeBtn) closeBtn.classList.add('vw-show');
  }

  // Secuencia: sobre aparece → sello se rompe y la solapa se abre →
  // la carta sale del sobre → el sobre desaparece → la carta se despliega → X
  addClass('vw-visible', 150);       // el sobre entra en escena
  addClass('vw-lid-open', 950);      // la solapa se abre
  addClass('vw-paper-out', 1550);    // el papel sale del sobre
  addClass('vw-envelope-hide', 2250);// el sobre se desvanece
  addClass('vw-card-visible', 2450); // la carta se despliega a tamaño completo

  // La X para cerrar aparece 3s después de que la carta esté totalmente abierta
  timers.push(setTimeout(function () {
    if (closeBtn) closeBtn.classList.add('vw-show');
  }, 2450 + 3000));

  if (closeBtn) {
    closeBtn.addEventListener('click', closeLetter);
  }
  if (reopenTab) {
    reopenTab.addEventListener('click', reopenLetter);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && closeBtn && closeBtn.classList.contains('vw-show') && overlay.style.display !== 'none') {
      closeLetter();
    }
  });
})();
